import { CardFrame } from "../../../../../../common/components/card-frame/CardFrame";
import DataTable, { ColumnType } from "../../../../../../common/components/xepp/table/DataTable";
import EmptyState from "../../../../../../common/components/xepp/empty-state/EmptyState";
import { TablePagination } from "../../../../../../common/components/xepp/table-pagination/TablePagination";
import { ReconcilliationTransactionDetail } from "../../../../../../model/reconcilliation/reconcilliation";
import styles from "./ExceptionTransactionsTable.module.scss";

export const PAGE_SIZE = 10;

interface ExceptionTransactionsTableProps {
	title: string;
	/** Summary figures for this section, shown on the right of the header. */
	summary: string;
	/** Every transaction in the section, in the order the job recorded them. */
	transactionIds: string[];
	/** The current page's rows. Fetched by the parent, alongside the other tables' pages. */
	rows: ReconcilliationTransactionDetail[];
	columns: ColumnType<ReconcilliationTransactionDetail>[];
	emptyDescription: string;
	page: number;
	onPageChange: (page: number) => void;
	isLoading: boolean;
}

export const ExceptionTransactionsTable = ({
	title,
	summary,
	transactionIds,
	rows,
	columns,
	emptyDescription,
	page,
	onPageChange,
	isLoading,
}: Readonly<ExceptionTransactionsTableProps>) => (
	<CardFrame headerSectionTitle={title} headerSectionRightContent={<span className={styles.summary}>{summary}</span>}>
		<div className={styles.body}>
			{transactionIds.length === 0 ? (
				<EmptyState title={title} description={emptyDescription} />
			) : (
				<>
					<DataTable data={rows} columns={columns} loading={isLoading} />
					<TablePagination
						totalItems={transactionIds.length}
						itemsPerPage={PAGE_SIZE}
						currentPage={page}
						onPageChange={onPageChange}
						isLoading={isLoading}
					/>
				</>
			)}
		</div>
	</CardFrame>
);
